// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@west/App/SharedStyles/CartLineSharedStyles";
import { cardStyles } from "@west/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { mergeWithCss } from "@west/XDL/Utilities";
import { css } from "styled-components";

cardStyles.productDescriptionText = {
    ...cartLineSharedStyles.productDescription?.productDetailDescription,
};

cardStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cardStyles.productNameLink = {
    ...cartLineSharedStyles.productDescription?.productDetailLink,
};

cardStyles.totalStyles = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.qtyInputStyle = {
    ...cartLineSharedStyles.qtyInputStyle,
};

cardStyles.image = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

cardStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

cardStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

cardStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};
